import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import { sendNavigationMetric } from "../../utils/sendMetric";

import strings from "../../locales/strings";

import styles from "./CargoOwnerButton.scss";

const cx = classnames.bind(styles);

const CargoOwnerButton = React.forwardRef(
  ({ baseUrl, className, locale }, ref) => {
    if (locale !== "ru") {
      return null;
    }

    const sendMetric = () => {
      sendNavigationMetric("CARGO_OWNER_BUTTON");
    };

    return (
      <a
        ref={ref}
        className={cx("cargo-owner-button", className)}
        href={`https://academy.${baseUrl}/shippers-start/?utm_source=header&utm_campaign=new_header&utm_content=button`}
        target="_blank"
        onClick={sendMetric}
      >
        {strings.cargoOwnerButtonAvailable}
      </a>
    );
  }
);

CargoOwnerButton.defaultProps = {
  baseUrl: "ati.su",
  locale: "ru",
};

CargoOwnerButton.propTypes = {
  baseUrl: PropTypes.string,
  className: PropTypes.string,
  locale: PropTypes.string,
};

export default CargoOwnerButton;
